import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PasswordTabs from './components/Tabs/Tabs';
import Error404 from './components/Error404/Error404';

const AppRouter = () => (
  <Router>
    <Routes>
      <Route path="/" element={<PasswordTabs />} />
      <Route path="/guide" element={<PasswordTabs />} />
      <Route path="/advanced" element={<PasswordTabs />} />
      <Route path="/validate" element={<PasswordTabs />} />
      {/* Catch-all for invalid routes */}
      <Route path="*" element={<Error404 />} />
    </Routes>
  </Router>
);

export default AppRouter;
